export default [
  {
    title: "Нэг. Ерөнхий заалт",
    items: [
      {
        text:
          "www.imj.mn цахим хуудас нь “Искүүл” ХХК-ний онлайн тест, сургалтын үйлчилгээний зориулалттай цахим хуудас бөгөөд энэхүү нөхцөл нь уг цахим хуудсаар үйлчлүүлэх, худалдан авалт хийхтэй холбоотой үүсэх харилцааг зохицуулахад оршино.",
      },
      {
        text:
          "Энэхүү нөхцөл нь хэрэглэгч цахим хуудасны үйлчилгээний нөхцлийг хүлээн зөвшөөрч бүртгүүлснээр хэрэгжинэ.",
      },
      {
        text:
          "Энэхүү үйлчилгээний нөхцөлийн хэрэгжилтэнд “Искүүл” ХХК /цаашид байгууллага гэх/ болон хэрэглэгч хамтран хяналт тавина.",
      },
    ],
  },
  {
    title: "Хоёр. Хэрэглэгчийн эрх үүрэг",
    items: [
      {
        text:
          "Цахим хуудсаар үйлчлүүлэхийг хүссэн хэрэглэгч бүртгүүлсэн байх.",
      },
      {
        text:
          "Хэрэглэгч цахим хуудсанд бүртгүүлэхийн тулд овог нэр, регистрийн дугаар, цахим шуудангийн хаяг, нууц үгийг оруулна.",
      },
      {
        text:
          "Хэрэглэгч зөвхөн нэг цахим шуудангийн хаягаар бүртгүүлнэ. Бүртгэлтэй хэрэглэгч нь өөрийн үйлчилгээний эрхээ бусдад дамжуулахгүй байх үүрэгтэй.",
      },
      {
        text:
          "Бүртгүүлэхдээ бүртгэлийн хэсэгт өөрийн тухай үнэн зөв мэдээллийг оруулж тэдгээрийн өөрчлөлтийг цаг тухай бүрд нь хийж байх үүрэгтэй.",
      },
      {
        text:
          "Хэрэглэгч нь www.imj.mn -д бүртгүүлснээр өөрийн сонгосон давхардаагүй хэрэглэгчийн нэр болон нууц үгийг үүсгэнэ. Хэрэглэгчийн нэр, нууц үгийг бүрэн хариуцах ба хэрэглэгчийн нэр, нууц үгээ дамжуулахгүй байж хэрэглэснийхээ дараа бүртгэлээ хааж байх, хэн нэгэн танд мэдэгдэлгүйгээр таны бүртгэлийг хэрэглэсэн байж болох сэжиг илэрвэл бидэнд яаралтай мэдэгдэх.",
      },
      {
        text:
          "Хэрэглэгч зөвхөн өөрийн сонгосон багцын бодлого, сорилуудыг ажиллах боломжтой.",
      },
      {
        text:
          "Хэрэглэгч цахим хуудасны үйл ажиллагааг сайжруулах талаар бүхий л санал илэрхийлэх, энэ тухай хүсэлтээ байгууллагад support@imj.mn  мэйл хаягаар илгээж болно.",
      },
      {
        text:
          "Хэрэглэгч нь цахим хуудасны үйл ажиллагаанд санаатайгаар саад хийхгүй байх үүрэгтэй.",
      },
    ],
  },
  {
    title: "Гурав. Байгууллагын эрх үүрэг",
    items: [
      {
        text: "Цахим хуудсыг тогтмол, хэвийн үйл ажиллагаатай байлгах үүрэгтэй.",
      },
      {
        text:
          "Цахим хуудсанд бүртгүүлсэн хэрэглэгчийн сонгосон багц үйлчилгээний төлбөр байгууллагын дансанд шилжин орж ирснээс хойш ажлын 1 өдрийн дотор тухайн хэрэглэгчийн үйлчилгээний эрхийг идэвхжүүлнэ.",
      },
      {
        text:
          "Хэрэглэгчийн оруулсан шаардлагатай мэдээлэл ямар нэгэн байдлаар худлаа байх эсвэл бид таны мэдээллийг худлаа гэдгийг шалтгаантайгаар сэжиглэвэл www.imj.mn нь тухайн хэрэглэгчийн бүртгэлийг хасах түүнд цаашид үйлчилгээ үзүүлэхээс татгалзах эрхтэй.",
      },
      {
        text: "Цахим хуудас дээр байрласан бодлогын үнэн зөв, бүрэн бүтэн байдлыг хариуцна.",
      },
      {
        text:
          "Үйлчилгээний нөхцөл шинэчлэгдэх тохиолдолд ажлын 5 хоногийн өмнө урьдчилан өөрийн цахим хуудсаар дамжуулан мэдэгдэнэ.",
      },
      {
        text:
          "Шаардлагатай тохиолдолд цахим хуудсанд засвар үйлчилгээ хийх бөгөөд засвар үйлчилгээг ажлын бус цагаар гүйцэтгэнэ.",
      },
      {
        text: "Хэрэглэгчээс ирүүлсэн санал гомдолд ажлын 5 хоногт багтаан хариу өгөх үүрэгтэй.",
      },
    ],
  },
  {
    title: "Дөрөв. Төлбөр тооцоо",
    items: [
      {
        text: "Онлайн бодлогын үнийг өөрийн цахим хуудсаар танилцуулна.",
      },
      {
        text:
          "Онлайн багцын үнэ өөрчлөгдөх, шинэчлэгдэх шаардлага гарвал хэрэглэгчийн өмнө нь сонгосон үйлчилгээний нөхцөлд өөрчлөлт оруулахгүй.",
      },
      {
        text: "Үйлчилгээний төлбөрийг “Искүүл” ХХК-ий ХААН банкны …  дансанд тушаана.",
      },
      {
        text:
          "Хэрэглэгч сонгосон багц үйлчилгээний төлбөрийг төлөн үйлчилгээгээ идэвхжүүлсэн тохиолдолд тухайн төлбөрийг өөр багц руу шилжүүлэх, төлбөрийг буцаах боломжгүй.",
      },
    ],
  },
  {
    title: "Тав. Бусад",
    items: [
      {
        text:
          "Цахим хуудасны бодлого, бодолт, зураг, лого, нэр болон бусад загвар, өгөгдлүүдийг хуулах, олшруулах, дуурайх, өөр бусад ямар нэгэн зүйлд ашиглахыг хориглоно.",
      },
      {
        text:
          "www.imj.mn-ийг улс төрийн сурталчилгаа хийх, бусдын нэр хүнд, хувийн нууцад халдах, ялгаварлан гадуурхах, дайрч доромжлох, зэрэгт ашиглахыг хориглох ба  энэ тохиолдолд Байгууллага нь хэрэглэгчийн эрхийг хасах, үйлчилгээ үзүүлэхээ зогсоох эрхтэй. ",
      },
      {
        text:
          "Үйлчилгээний нөхцөл болон төлбөр тооцоотой холбогдон гарсан асуудлыг Монгол улсын хууль дүрмийн дагуу шийдвэрлэнэ. ",
      },
    ],
  },
];
